
import Cookies from 'js-cookie'

document.addEventListener( 'DOMContentLoaded', function () {

    // Check if cookie consent is active
    var cookieConsentLinks = document.getElementsByClassName("cookie-consent");
    var cookieConsentContainer = document.getElementById("cookie-consent-container");

    Array.from(cookieConsentLinks).forEach(function(element) {

        element.addEventListener('click', acceptCookieConsent);
    
    });

    if (cookieConsentLinks.length > 0) {

        if(Cookies.get('cookie-consent')) {

            cookieConsentContainer.classList.add("hidden");

            activateScripts();

        } else {
             
            // Do nothing
            
        }

    }

    function acceptCookieConsent() {

        Cookies.set('cookie-consent', 'accepted', { expires: 60 })
    
        cookieConsentContainer.classList.add("hidden");

        activateScripts();
        
    }

});

// If state to activate is true, run all scripts using data-attributes
function activateScripts() {

    var gtagSource = document.createElement("script");
    gtagSource.src = "https://www.googletagmanager.com/gtag/js?id=G-91EYT09EMG";
    gtagSource.asyn = true;
    document.head.appendChild(gtagSource);  

    var gtagWindow = document.createElement("script");
    gtagWindow.innerHTML = "window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'G-91EYT09EMG');";
    document.head.appendChild(gtagWindow);  

    const scripts = document.querySelectorAll('script[data-cookie-consent]');

    Array.from(scripts).forEach(function(script) {  

        if(script.getAttribute('data-src')) {

            script.src = script.getAttribute('data-src');

        } 

        if(script.type = 'type/plain') {

            script.type = 'type/javascript';

        } 
        
    });

}

